export default "__VITE_ASSET__e$iRO6tg__"